(function () {
  if (window.__customCarouselTabJsInit) return;
  window.__customCarouselTabJsInit = true;

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function CompetitorProductCarousel(section) {
    this.section = section;
    this.cards = qsa(section, '.cp-card');
    this.modelTabs = qsa(section, '[data-tab-index]');
    this.outUrl = qs(section, '[data-out="url"]');
    this.outVariantId = qs(section, '[data-out="variant_id"]');
    this.outAddToCartButton = qs(section, '[data-out="add_to_cart_button"]');
    this.outKicker = qs(section, '[data-out="kicker"]');
    this.outSubtitle = qs(section, '[data-out="subtitle"]');
    this.specOut = [];
    for (var i = 1; i <= 4; i++) {
      this.specOut.push({
        title: qs(section, '[data-out="spec' + i + '_title"]'),
        text: qs(section, '[data-out="spec' + i + '_text"]'),
      });
    }
    this.hotspotModal = qs(section, '[data-cp-hotspot-modal]');
    this.hotspotModalPanel = this.hotspotModal ? qs(this.hotspotModal, '[data-cp-hotspot-modal-panel]') : null;
    this.hotspotModalDots = this.hotspotModal ? qs(this.hotspotModal, '[data-cp-hotspot-modal-dots]') : null;
    this.hotspotModalTitle = this.hotspotModal ? qs(this.hotspotModal, '.cp-hotspot-modal__title') : null;
    this.hotspotModalMedia = this.hotspotModal ? qs(this.hotspotModal, '[data-cp-hotspot-modal-media]') : null;
    this.hotspotModalImg = this.hotspotModalMedia ? qs(this.hotspotModalMedia, '.cp-hotspot-modal__img') : null;
    this.hotspotModalDesc = this.hotspotModal ? qs(this.hotspotModal, '.cp-hotspot-modal__desc') : null;
    this.hotspotModalCounterLive = this.hotspotModal ? qs(this.hotspotModal, '[data-cp-hotspot-modal-counter-live]') : null;
    this.tabRail = qs(section, '[data-cp-tab-rail]');
    this._hotspotModalItems = [];
    this._hotspotModalIndex = 0;
    this._hotspotModalOpen = false;
    this._bodyScrollLockActive = false;
    this._bodyScrollLockY = 0;
    this._hotspotModalKeyHandler = this._hotspotModalKeyHandler.bind(this);
    this.currentIndex = 0;
    if (!this.cards.length) return;
    this.init();
  }

  CompetitorProductCarousel.prototype.init = function () {
    var self = this;

    if (this.hotspotModal) {
      this.hotspotModal.addEventListener('click', function (event) {
        event.stopPropagation();
        var isBackdrop = event.target.closest('.cp-hotspot-modal__backdrop');
        if (isBackdrop) {
          event.preventDefault();
          self.closeHotspotModal();
          return;
        }
      });
    }

    if (this.hotspotModalDots) {
      this.hotspotModalDots.addEventListener('click', function (event) {
        var dot = event.target.closest('.cp-hotspot-modal__dot');
        if (!dot || !self.hotspotModalDots.contains(dot)) return;
        event.preventDefault();
        if (!self._hotspotModalOpen) return;
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(idx) || idx < 0 || idx >= self._hotspotModalItems.length) return;
        self._hotspotModalIndex = idx;
        self.renderHotspotModalSlide();
      });
    }

    if (this.hotspotModalPanel) {
      var swipeSx = 0;
      var swipeSy = 0;
      var swipeBodyScrollTop = 0;
      var ptrDown = false;
      var ptrStartX = 0;
      var ptrStartY = 0;
      this.hotspotModalPanel.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          swipeSx = e.touches[0].clientX;
          swipeSy = e.touches[0].clientY;
          var bodyEl = qs(self.hotspotModalPanel, '.cp-hotspot-modal__body');
          swipeBodyScrollTop = bodyEl ? bodyEl.scrollTop : 0;
        },
        { passive: true }
      );
      this.hotspotModalPanel.addEventListener(
        'touchend',
        function (e) {
          if (!self._hotspotModalOpen) return;
          if (e.changedTouches.length !== 1) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - swipeSx;
          var dy = t.clientY - swipeSy;
          var ax = Math.abs(dx);
          var ay = Math.abs(dy);
          var threshold = 46;
          var dismissDy = 56;
          if (ax < threshold && ay < threshold) return;
          if (ay > ax && dy > dismissDy && swipeBodyScrollTop === 0) {
            self.closeHotspotModal();
            return;
          }
          if (ax >= ay && ax > threshold && self._hotspotModalItems.length > 1) {
            if (dx < 0) self.stepHotspotModal(1);
            else self.stepHotspotModal(-1);
          }
        },
        { passive: true }
      );
      this.hotspotModalPanel.addEventListener('pointerdown', function (e) {
        if (!self._hotspotModalOpen || e.pointerType === 'touch') return;
        if (e.button !== 0) return;
        if (e.target.closest('.cp-hotspot-modal__dot')) return;
        ptrDown = true;
        ptrStartX = e.clientX;
        ptrStartY = e.clientY;
        try {
          self.hotspotModalPanel.setPointerCapture(e.pointerId);
        } catch (err) {}
      });
      this.hotspotModalPanel.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'touch') return;
        if (ptrDown) {
          try {
            self.hotspotModalPanel.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
        if (!self._hotspotModalOpen || !ptrDown) {
          ptrDown = false;
          return;
        }
        ptrDown = false;
        var bodyEl = qs(self.hotspotModalPanel, '.cp-hotspot-modal__body');
        var scrollTop = bodyEl ? bodyEl.scrollTop : 0;
        var dx = e.clientX - ptrStartX;
        var dy = e.clientY - ptrStartY;
        var ax = Math.abs(dx);
        var ay = Math.abs(dy);
        var threshold = 48;
        var dismissDy = 56;
        if (ax < threshold && ay < threshold) return;
        if (ay > ax && dy > dismissDy && scrollTop === 0) {
          self.closeHotspotModal();
          return;
        }
        if (ax >= ay && ax > threshold && self._hotspotModalItems.length > 1) {
          if (dx < 0) self.stepHotspotModal(1);
          else self.stepHotspotModal(-1);
        }
      });
      this.hotspotModalPanel.addEventListener('pointercancel', function (e) {
        ptrDown = false;
        try {
          self.hotspotModalPanel.releasePointerCapture(e.pointerId);
        } catch (err) {}
      });
    }

    this.section.addEventListener('click', function (event) {
      if (event.target.closest('[data-cp-hotspot-modal]')) return;
      var clickedHotspot = event.target.closest('[data-hotspot]');
      if (clickedHotspot) {
        event.preventDefault();
        event.stopPropagation();
        var activeCard = self.cards[self.currentIndex];
        if (!activeCard) return;
        var hotspots = qsa(activeCard, '[data-hotspot]');
        var startIdx = hotspots.indexOf(clickedHotspot);
        if (startIdx < 0) return;
        self.openHotspotModal(hotspots, startIdx);
        return;
      }
      var clickedTab = event.target.closest('[data-tab-index]');
      if (clickedTab) {
        event.preventDefault();
        var next = parseInt(clickedTab.getAttribute('data-tab-index'), 10);
        if (!isNaN(next)) {
          self.currentIndex = next;
          self.render();
        }
        return;
      }
      self.closeHotspots();
      self.closeHotspotModal();
    });
    this.render();
  };

  CompetitorProductCarousel.prototype._applyBodyScrollLock = function () {
    if (this._bodyScrollLockActive) return;
    if (typeof window.matchMedia === 'function' && !window.matchMedia('(max-width: 768px)').matches) return;
    this._bodyScrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + this._bodyScrollLockY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    this._bodyScrollLockActive = true;
  };

  CompetitorProductCarousel.prototype._releaseBodyScrollLock = function () {
    if (!this._bodyScrollLockActive) return;
    var y = this._bodyScrollLockY || 0;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    window.scrollTo(0, y);
    this._bodyScrollLockActive = false;
    this._bodyScrollLockY = 0;
  };

  CompetitorProductCarousel.prototype.openHotspotModal = function (hotspotNodes, startIndex) {
    if (!this.hotspotModal || !this.hotspotModalTitle || !this.hotspotModalDesc) return;
    var items = [];
    for (var i = 0; i < hotspotNodes.length; i++) {
      var pop = qs(hotspotNodes[i], '.cp-hotspot-popup');
      var tEl = pop ? qs(pop, '.cp-hotspot-title') : null;
      var dEl = pop ? qs(pop, '.cp-hotspot-desc') : null;
      var imgEl = pop ? qs(pop, 'img.cp-hotspot-img') : null;
      items.push({
        title: tEl ? tEl.textContent.trim() : '',
        desc: dEl ? dEl.textContent.trim() : '',
        imgSrc: imgEl && imgEl.getAttribute('src') ? imgEl.getAttribute('src') : '',
        imgSrcset: imgEl && imgEl.getAttribute('srcset') ? imgEl.getAttribute('srcset') : '',
        imgSizes: imgEl && imgEl.getAttribute('sizes') ? imgEl.getAttribute('sizes') : '',
        imgAlt: imgEl && imgEl.getAttribute('alt') != null ? imgEl.getAttribute('alt') : '',
      });
    }
    if (!items.length) return;
    this._hotspotModalItems = items;
    this._hotspotModalIndex = Math.max(0, Math.min(startIndex, items.length - 1));
    this.hotspotModal.removeAttribute('hidden');
    this.hotspotModal.setAttribute('aria-hidden', 'false');
    this._hotspotModalOpen = true;
    document.addEventListener('keydown', this._hotspotModalKeyHandler);
    document.documentElement.classList.add('cp-hotspot-modal-open');
    this._applyBodyScrollLock();
    this.renderHotspotModalSlide();
  };

  CompetitorProductCarousel.prototype.closeHotspotModal = function () {
    if (!this.hotspotModal || !this._hotspotModalOpen) return;
    this.hotspotModal.setAttribute('hidden', '');
    this.hotspotModal.setAttribute('aria-hidden', 'true');
    this._hotspotModalOpen = false;
    document.removeEventListener('keydown', this._hotspotModalKeyHandler);
    document.documentElement.classList.remove('cp-hotspot-modal-open');
    this._releaseBodyScrollLock();
    this._hotspotModalItems = [];
  };

  CompetitorProductCarousel.prototype.stepHotspotModal = function (delta) {
    var n = this._hotspotModalItems.length;
    if (n < 2) return;
    this._hotspotModalIndex = (this._hotspotModalIndex + delta + n) % n;
    this.renderHotspotModalSlide();
  };

  CompetitorProductCarousel.prototype.renderHotspotModalSlide = function () {
    var item = this._hotspotModalItems[this._hotspotModalIndex];
    if (!item || !this.hotspotModalTitle || !this.hotspotModalDesc) return;
    this.hotspotModalTitle.textContent = item.title;
    this.hotspotModalDesc.textContent = item.desc;
    if (this.hotspotModalMedia && this.hotspotModalImg) {
      if (item.imgSrc) {
        this.hotspotModalMedia.removeAttribute('hidden');
        this.hotspotModalImg.setAttribute('src', item.imgSrc);
        if (item.imgSrcset) this.hotspotModalImg.setAttribute('srcset', item.imgSrcset);
        else this.hotspotModalImg.removeAttribute('srcset');
        if (item.imgSizes) this.hotspotModalImg.setAttribute('sizes', item.imgSizes);
        else this.hotspotModalImg.removeAttribute('sizes');
        this.hotspotModalImg.setAttribute('alt', item.imgAlt || item.title || '');
      } else {
        this.hotspotModalMedia.setAttribute('hidden', '');
        this.hotspotModalImg.removeAttribute('src');
        this.hotspotModalImg.removeAttribute('srcset');
        this.hotspotModalImg.removeAttribute('sizes');
        this.hotspotModalImg.setAttribute('alt', '');
      }
    }
    var n = this._hotspotModalItems.length;
    if (this.hotspotModalCounterLive) {
      this.hotspotModalCounterLive.textContent =
        n > 1 ? item.title + ' — ' + (this._hotspotModalIndex + 1) + ' / ' + n : item.title;
    }
    if (this.hotspotModalDots) {
      this.hotspotModalDots.innerHTML = '';
      if (n >= 1) {
        this.hotspotModalDots.removeAttribute('hidden');
        this.hotspotModalDots.setAttribute('aria-hidden', 'false');
        for (var i = 0; i < n; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cp-hotspot-modal__dot' + (i === this._hotspotModalIndex ? ' is-active' : '');
          dot.setAttribute('data-index', String(i));
          dot.setAttribute(
            'aria-label',
            (this._hotspotModalItems[i].title || 'Hotspot') + ' (' + (i + 1) + ' / ' + n + ')'
          );
          dot.setAttribute('aria-current', i === this._hotspotModalIndex ? 'true' : 'false');
          this.hotspotModalDots.appendChild(dot);
        }
      } else {
        this.hotspotModalDots.setAttribute('hidden', '');
        this.hotspotModalDots.setAttribute('aria-hidden', 'true');
      }
    }
  };

  CompetitorProductCarousel.prototype.updateTabRail = function () {
    if (!this.tabRail) return;
    var tabs = this.modelTabs;
    this.tabRail.innerHTML = '';
    if (!tabs.length) {
      this.tabRail.setAttribute('hidden', '');
      return;
    }
    this.tabRail.removeAttribute('hidden');
    for (var i = 0; i < tabs.length; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cp-tab-rail__seg' + (i === this.currentIndex ? ' is-active' : '');
      btn.setAttribute('data-tab-index', String(i));
      btn.setAttribute('aria-label', (tabs[i].textContent || '').trim() || 'Model ' + (i + 1));
      btn.setAttribute('aria-current', i === this.currentIndex ? 'true' : 'false');
      this.tabRail.appendChild(btn);
    }
  };

  CompetitorProductCarousel.prototype._hotspotModalKeyHandler = function (event) {
    if (!this._hotspotModalOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeHotspotModal();
      return;
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.stepHotspotModal(-1);
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.stepHotspotModal(1);
    }
  };

  CompetitorProductCarousel.prototype.normalize = function (i) {
    return (i + this.cards.length) % this.cards.length;
  };

  CompetitorProductCarousel.prototype.updateMeta = function (card) {
    if (!card) return;
    if (this.outKicker) this.outKicker.textContent = card.dataset.kicker || '';
    if (this.outSubtitle) this.outSubtitle.textContent = card.dataset.subtitle || '';
    var ds = card.dataset;
    for (var i = 0; i < 4; i++) {
      var n = i + 1;
      var o = this.specOut[i];
      var T = ds['spec' + n + 'Title'];
      var X = ds['spec' + n + 'Text'];
      if (o.title) o.title.textContent = T || '';
      if (o.text) o.text.textContent = X || '';
    }
    if (this.outUrl) this.outUrl.setAttribute('href', card.dataset.url || '#');
    var variantId = card.dataset.variantId || '';
    if (this.outVariantId) this.outVariantId.value = variantId;
    if (this.outAddToCartButton) this.outAddToCartButton.disabled = !variantId;
  };

  CompetitorProductCarousel.prototype.render = function () {
    if (!this.cards.length) return;
    this.currentIndex = this.normalize(this.currentIndex);
    var self = this;
    this.cards.forEach(function (card, idx) {
      card.classList.toggle('is-active', idx === self.currentIndex);
    });
    this.modelTabs.forEach(function (tab, idx) {
      tab.classList.toggle('is-active', idx === self.currentIndex);
    });
    this.updateMeta(this.cards[this.currentIndex]);
    this.closeHotspots();
    this.closeHotspotModal();
    this.updateTabRail();
  };

  CompetitorProductCarousel.prototype.closeHotspots = function () {
    qsa(this.section, '[data-hotspot].is-open').forEach(function (hotspot) {
      hotspot.classList.remove('is-open');
    });
  };

  function wakeHotspots(root) {
    qsa(root, '.cp-hotspots--idle').forEach(function (el) {
      el.classList.remove('cp-hotspots--idle');
    });
  }

  function bindSection(sectionRoot) {
    var inner = qs(sectionRoot, '.cp-section');
    if (!inner || inner.dataset.cpReady === '1') return;
    inner.dataset.cpReady = '1';
    var layout = qs(sectionRoot, '[data-cp-layout]');
    var run = function () {
      wakeHotspots(sectionRoot);
      new CompetitorProductCarousel(inner);
    };
    if (!layout || !('IntersectionObserver' in window)) {
      run();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) {
          return e.isIntersecting;
        })) {
          io.disconnect();
          run();
        }
      },
      { rootMargin: '160px 0px', threshold: 0.01 }
    );
    io.observe(layout);
  }

  function bootAllCustomCarouselTabs() {
    qsa(document, '.cp-section.custom-carousel-tab').forEach(function (inner) {
      var sectionRoot = inner.closest('[id^="shopify-section-"]');
      if (sectionRoot) bindSection(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllCustomCarouselTabs);
  } else {
    bootAllCustomCarouselTabs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var t = event.target;
    if (!t || !t.id || t.id.indexOf('shopify-section-') !== 0) return;
    if (!qs(t, '.cp-section.custom-carousel-tab')) return;
    bindSection(t);
  });
})();
